if (!Array.from) {
    Array.from = function (object) {
        'use strict';
        return [].slice.call(object);
    };
}


// WEBPACK FOOTER //
// ./src/polyfill.tsx